export default "__VITE_ASSET__DvGxrWiI__"